import * as requestActions from "../requestActions";
import { intl } from "../../intl";
import managementService from "../../api/managementService";

export const fetchMeetingList = (filter) => {
  return async (dispatch) => {
    let response = await managementService.getMeetingList(filter);
    if (!response.data.error) {
      dispatch({
        type: "FETCH_MEETING_LIST",
        payload: response.data.payload,
      });
    }
  };
};

export const fetchMeeting = (id) => {
  return async (dispatch) => {
    let response = await managementService.getMeeting(id);
    if (!response.data.error) {
      dispatch({
        type: "FETCH_MEETING",
        payload: response.data.payload,
      });
    }
  };
};

export const setOfficialReportOpen = (isOpen) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_OPEN_OFFICIAL_REPORT",
      payload: isOpen,
    });
  };
};

export const fetchMeetingListFirst = (filter) => {
  return async (dispatch) => {
    let response = await managementService.getMeetingList(filter);
    if (!response.data.error) {
      dispatch({
        type: "FETCH_MEETING_LIST_FIRST",
        payload: response.data.payload,
      });
    }
  };
};

export const createMeeting = (meeting) => {
  return async (dispatch) => {
    let response = await managementService.createMeeting(meeting);
    if (response.status === 200 && !response.data.error) {
      dispatch(
        {
          type: "CREATE_NEW_MEETING",
          payload: response.data.payload,
        },
        requestActions.notify({
          text: intl.formatMessage({
            id: "user.meetingCreatedSuccessfully",
            defaultMessage: "New meeting created successfully",
          }),
        })
      );
    } else if (
      response.status === 200 &&
      response.data.error &&
      response.data.payload === "MAX_500_EXTERNAL_USER"
    ) {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "meeting.max500ExternalUser",
            defaultMessage: "Max 500 external user",
          }),
        })
      );
    } else {
      dispatch(
        requestActions.notify({
          text: intl.formatMessage({
            id: "management.operationFailed",
            defaultMessage: "Operation failed!",
          }),
        })
      );
    }
  };
};

export const editMeeting = (meeting) => {
  return async (dispatch) => {
    let response = await managementService.editMeeting(meeting);
    if (!response.data.error) {
      dispatch(
        {
          type: "EDIT_MEETING",
          payload: response.data.payload,
        },
        requestActions.notify({
          text: intl.formatMessage({
            id: "user.meetingUpdatedSuccessfully",
            defaultMessage: "Meeting updated successfully",
          }),
        })
      );
    } else if (
      response.status === 200 &&
      response.data.error &&
      response.data.payload === "MAX_500_EXTERNAL_USER"
    ) {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "meeting.max500ExternalUser",
            defaultMessage: "Max 500 external user",
          }),
        })
      );
    } else {
      dispatch(
        requestActions.notify({
          text: intl.formatMessage({
            id: "management.operationFailed",
            defaultMessage: "Operation failed!",
          }),
        })
      );
    }
  };
};

export const setMeeting = (officialReport) => {
  return async (dispatch) => {
    dispatch(
      {
        type: "EDIT_FETCHED_MEETING",
        payload: officialReport,
      },
      requestActions.notify({
        text: intl.formatMessage({
          id: "user.meetingUpdatedSuccessfully",
          defaultMessage: "Meeting updated successfully",
        }),
      })
    );
  };
};

export const deleteMeeting = (ids) => {
  return async (dispatch) => {
    let response = await managementService.deleteAllMeetings(ids);
    if (!response.data.error) {
      dispatch({
        type: "DELETE_MEETING",
        payload: response.data.payload,
      });
    } else
      dispatch(
        requestActions.notify({
          text: intl.formatMessage({
            id: "management.operationFailed",
            defaultMessage: "Operation failed!",
          }),
        })
      );
  };
};
